module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-08-18 at 7.32.13 AM.3ba5e7fa.png";